<ion-app>
  <ion-router-outlet id="menuContent"></ion-router-outlet>
  <div class="ipad-spinner" *ngIf="showIpadSpinner">
    <ion-spinner name="lines"></ion-spinner>
  </div>
<app-menu></app-menu>
</ion-app>